// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"403":"15a619a1","510":"8dd42c16","636":"a9f13a0e","752":"28a7cf89"}[chunkId] + ".chunk.css";
};